module.exports = __webpack_public_path__ + "static/media/banner.86dab435.jpg";